import React, { useEffect, useState } from "react";
import { AzureAD } from "react-aad-msal";
import PrimaryLink from "../../elements/primary-link";
import store from "../../redux/store/store";
import "./style.scss";
import { getStoreInfo } from "../../services/storeService";
import { connect } from "react-redux";
import { clearCart, getCart } from "../../services/cartService";
import { setSessionIdAction, clearCartAction } from "../../redux/actions/actions";
import { selectUserState, selectCartItemsState, selectSessionId } from "../../selectors/application";

// Import the authentication provider which holds the default settings
import { authProvider } from "../../services/authProvider";
import { canUseDOM } from "../../utils";
import { setStaffInfoAction } from "../../redux/actions";
import { setStore } from "../../redux/actions/actions";
import { S_STAFF_INFO, webStorage } from "../../utils/webStorage";

const StaffBanner = ({ rendering, fields, club, setStaffInfo, setStoreInfo, sessionId, user, lang }) => {
  const [storedStore, setStoredStore] = useState();

  useEffect(() => {
    setStoredStore(getStoreInfo());
  }, [club]);

  const clicklogout = async () => {
    setStaffInfo(null);
    webStorage.clear(S_STAFF_INFO);
    setStoreInfo(null);
    await clearCartOnStaffLogout();
  };

  if (!canUseDOM()) return null;

  const clearCartOnStaffLogout = async () => {
    let currentShoppingCart = await getCart(lang);
    let skuListToremove = [];
    if (currentShoppingCart.obj && currentShoppingCart.obj.skuList) {
      currentShoppingCart.obj.skuList.forEach(item => {
        skuListToremove.push({ skuCount: item.skuCount, skuId: item.skuId });
      });
    }
    if (skuListToremove.length > 0) {
      await clearCart(skuListToremove, user?.userAccount, sessionId);
    }
    clearCartAction();
  };
  return (
    <div className="staff-banner grid" datasourceid={rendering.dataSource}>
      <AzureAD provider={authProvider} reduxStore={store}>
        {({ accountInfo, logout, error }) => {
          return (
            <React.Fragment>
              <div className="main-content-container">
                {accountInfo && (
                  <div className="main-content">
                    <div className="name">
                      <p>{accountInfo.account.name}</p>

                      <p>{accountInfo.account.userName}</p>
                    </div>
                    <div className="store">
                      <p>{storedStore?.value}</p>
                    </div>
                    <div
                      onClick={() => {
                        clicklogout().then(() => {
                          logout();
                        });
                      }}
                    >
                      <PrimaryLink
                        {...{
                          ...fields.logoutButton?.fields,
                          buttonText: fields.logoutButton?.fields.buttonText.value
                        }}
                      />
                    </div>
                  </div>
                )}

                {error && (
                  <div className="main-content">
                    <div>
                      <p>
                        <span style={{ fontWeight: "bold" }}>errorCode:</span> {error.errorCode}
                      </p>
                      <p>
                        <span style={{ fontWeight: "bold" }}>errorMessage:</span>
                        {error.errorMessage}
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </React.Fragment>
          );
        }}
      </AzureAD>
    </div>
  );
};

const mapStateToProps = state => ({
  club: state.club,
  sessionId: selectSessionId(state)
});
const mapDispatchToProps = dispatch => ({
  setStaffInfo: data => dispatch(setStaffInfoAction(data)),
  setStoreInfo: data => dispatch(setStore(data)),
  setSessionId: sessionId => dispatch(setSessionIdAction(sessionId)),
  clearCartAction: () => dispatch(clearCartAction())
});
export default connect(mapStateToProps, mapDispatchToProps)(StaffBanner);
